import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import useCartContext from '../hooks/useCartContext';
import Navbar from './Navbar';
import './Cart.css';

const Cart = () => {
  const { currentUser } = useAuth();
  const { cart, setCart } = useCartContext();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setIsLoading] = useState(false);

   // 🔹 Estado para la opción de entrega
   const [deliveryOption, setDeliveryOption] = useState('local');
   const [address, setAddress] = useState("");
    const [addressNumber, setAddressNumber] = useState("");
    const [apartment, setApartment] = useState("");
    const [selectedStore, setSelectedStore] = useState("Chacabuco y Lavalle"); // Valor por defecto
    const [paymentMethod, setPaymentMethod] = useState("mercadoPago");

useEffect(() => {
  if (currentUser) {
    console.log("👤 Usuario autenticado:");
    console.log("🔸 ID (uid):", currentUser.uid);
    console.log("🔸 Email:", currentUser.email);
    console.log("🔸 Nombre:", currentUser.displayName);
    console.log("🔸 Proveedor:", currentUser.providerId);
    console.log("🔸 Objeto completo:", currentUser);
  } else {
    console.log("🚫 No hay usuario autenticado.");
  }
}, [currentUser]);


  useEffect(() => {
    setTotalItems(cart.length);
  }, [cart]);


  const handleCheckout = async () => {
  if (!currentUser) {
    setMessage("Por favor, inicia sesión para realizar la compra.");
    navigate("/");
    return;
  }

  if (deliveryOption === "domicilio" && address.trim() === "") {
    setMessage("Por favor, ingresa una dirección.");
    return;
  }

  try {
    setIsLoading(true);

    const items = cart.map(product => ({
      id: product.firebaseId || product.id,
      // 🔒 NO enviar unit_price - el servidor lo calcula desde BD
      quantity: product.quantity,
      isCombo: product.isCombo || false,
    }));

    const requestData = {
      items,
      userId: currentUser.uid,
      email: currentUser.email,
      deliveryOption,
      addressNumber,
      apartment,
      address,
      selectedStore,
      paymentMethod,
    };

    console.log("📌 Datos a enviar:", JSON.stringify(requestData, null, 2));

    if (paymentMethod === "efectivo") {
      const response = await fetch("https://createcashorder-gimkn5c4xa-uc.a.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      if (response.ok) {
        setCart([]);
        setMessage("Pedido registrado con éxito. Gracias por tu compra.");
        navigate("/success");
        return; // 🔹 EVITA que se siga ejecutando el bloque de Mercado Pago
      } else {
        throw new Error(result.error || "Error al registrar el pedido.");
      }
    }



    // 🔹 Si es Mercado Pago
    const response = await fetch("https://createmercadopagopreference-gimkn5c4xa-uc.a.run.app", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    const responseData = await response.json();
    console.log("📌 Respuesta del servidor:", responseData);

    if (response.ok && responseData.init_point) {
      setCart([]);
      window.location.href = responseData.init_point;
    } else {
      throw new Error(responseData.message || "No se pudo generar la preferencia de pago.");
    }
  } catch (error) {
    console.error("❌ Error en el proceso de compra:", error);
    setMessage(error.message || "Error al realizar la compra.");
  } finally {
    setIsLoading(false);
  }
};

  


   // Para cerrar el mensaje manualmente
   const handleCloseMessage = () => {
    setMessage(''); // Limpiar el mensaje
  };


  // Función para eliminar un producto del carrito
  const removeFromCart = (productId) => {
    const updatedCart = cart.filter(product => product.id !== productId);
    setCart(updatedCart);
    setMessage('Producto eliminado del carrito.');
  };

  return (
    <div>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loading-icon"></div>
            Procesando tu compra, por favor espera...
          </div>
        </div>
      )}
      <>
        <Navbar cartItemCount={totalItems} clearCart={() => setCart([])} />
        <div className="cart-container">
          <h2>Carrito de Compras</h2>
          {message && (
            <div className="message-container">
              <p className="message">{message}</p>
              <button onClick={handleCloseMessage} className="close-message-button">Cerrar</button>
            </div>
          )}

          {cart.length === 0 ? (
            <p className="empty-cart-message">No hay productos en el carrito.</p>
          ) : (
            <div>
              {cart.map(product => {
                const discountedPrice = product.discount > 0
                ? (Number(product.price) * (1 - product.discount / 100)).toFixed(2)
                : product.discountInPesos > 0
                ? (Number(product.price) - product.discountInPesos).toFixed(2)
                : Number(product.price).toFixed(2);

                return (
                  <div key={product.id} className="cart-item">
                    <img src={product.image} alt={product.name} className="cart-image" />
                    <div className="cart-details">
                      <h3>{product.name}</h3>
                      <p>{product.description}</p>
                      <p>Cantidad: {product.quantity}</p>

                      {product.discount > 0 ? (
                        <>
                          <p>Precio Original: <s>${product.price}</s></p>
                          <p>Descuento: {product.discount}%</p>
                          <p>Precio con Descuento: ${discountedPrice}</p>
                        </>
                      ) : product.discountInPesos > 0 ? (
                        <>
                          <p>Precio Original: <s>${product.price}</s></p>
                          <p>Descuento: ${product.discountInPesos}</p>
                          <p>Precio con Descuento: ${discountedPrice}</p>
                        </>
                      ) : (
                        <p>Precio: ${product.price}</p>
                      )}

                      <button onClick={() => removeFromCart(product.id)}>Eliminar</button>
                    </div>
                  </div>
                );
              })}

              <div className="cart-summary">
                <p><strong>Total de Productos:</strong> {totalItems}</p>
                <p>
                  <strong>Total a Pagar:</strong> $
                  {cart.reduce((total, product) => {
                    const discountedPrice = product.discount > 0
                    ? (Number(product.price) * (1 - product.discount / 100)).toFixed(2)
                    : product.discountInPesos > 0
                    ? (Number(product.price) - product.discountInPesos).toFixed(2)
                    : Number(product.price).toFixed(2);


                    return total + discountedPrice * product.quantity;
                  }, 0).toFixed(2)}
                </p>
              </div>

              {/* 🔹 Opciones de pago */}
              <div className="payment-options">
                <h3>Selecciona el método de pago:</h3>
                <label>
                  <input
                    type="radio"
                    value="mercadoPago"
                    checked={paymentMethod === 'mercadoPago'}
                    onChange={() => setPaymentMethod('mercadoPago')}
                  />
                  Mercado Pago
                </label>
                <label>
                  <input
                    type="radio"
                    value="efectivo"
                    checked={paymentMethod === 'efectivo'}
                    onChange={() => setPaymentMethod('efectivo')}
                  />
                  Pago en Efectivo
                </label>
              </div>


             {/* 🔹 Opciones de entrega */}
              <div className="delivery-options">
                <h3>Selecciona el método de entrega:</h3>
                <label>
                  <input
                    type="radio"
                    value="local"
                    checked={deliveryOption === 'local'}
                    onChange={() => setDeliveryOption('local')}
                  />
                  Retiro en Local
                </label>
                <label>
                  <input
                    type="radio"
                    value="domicilio"
                    checked={deliveryOption === 'domicilio'}
                    onChange={() => setDeliveryOption('domicilio')}
                    disabled
                  />
                  Envío a Domicilio (no disponible por ahora)
                </label>

                {/* 🔹 Opciones si elige "Retiro en Local" */}
                {deliveryOption === 'local' && (
                  <div className="store-selection">
                    <label>Selecciona el local:</label>
                    <select value={selectedStore} onChange={(e) => setSelectedStore(e.target.value)}>
                      <option value="Chacabuco y Lavalle">Sucursal 1 - Chacabuco y Lavalle</option>
                      <option value="9 de Julio y Saavedra">Sucursal 2 - 9 de Julio y Saavedra</option>
                      <option value="Almafuerte y Quintana">Sucursal 3 - Almafuerte y Quintana</option>
                    </select>
                  </div>
                )}

                {/* 🔹 Opciones si elige "Envío a Domicilio" */}
                {deliveryOption === 'domicilio' && (
                  <div className="address-input">
                    <label>Dirección de Entrega:</label>
                    <input
                      type="text"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Calle"
                      required
                    />

                    <label>Número de Dirección:</label>
                    <input
                      type="text"
                      value={addressNumber}
                      onChange={(e) => setAddressNumber(e.target.value)}
                      placeholder="Ej: 123"
                      required
                    />

                    <label>Piso / Departamento (opcional):</label>
                    <input
                      type="text"
                      value={apartment}
                      onChange={(e) => setApartment(e.target.value)}
                      placeholder="Ej: Piso 2, Depto B"
                    />
                  </div>
                )}
              </div>
              

              <button onClick={handleCheckout} className="checkout-button">Realizar Pedido</button>
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default Cart;